import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { CreatedEntity } from "@/api/entities/entities.mutations.types";

type EntitiesState = {
  lastCreatedEntity: CreatedEntity | null;
  setLastCreatedEntity: (entity: CreatedEntity | null) => void;
};

export const useEntitiesStore = create<EntitiesState>()(
  persist(
    (set) => ({
      lastCreatedEntity: null,
      setLastCreatedEntity: (entity) => set({ lastCreatedEntity: entity }),
    }),
    { name: "entities-store" },
  ),
);
